import axiosInstance from './axiosInstance';

export const registerUser = async (userData) => {
  return await axiosInstance.post('/api/auth/register/', userData);
};

export const resetPassword = async (uid, token, passwordData) => {
  return await axiosInstance.post(`/api/auth/cambiar-contrasena/${uid}/${token}/`, passwordData);
};

export const requestPassword = async (data) => {
  return await axiosInstance.post('/api/auth/recuperar-contrasena/', data);
};

export const login = async (data) => {
  return await axiosInstance.post('/api/auth/iniciar-sesion/', data);
};

export const logOut = async () => {
  return await axiosInstance.post('/api/auth/logout/');
};

export const updateUserPhoto = async (formData) => {
  return await axiosInstance.patch(`api/auth/perfil/photo/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};